import "./HeaderComponent.scss";
import aziendaZero from '../../assests/AziendaZero.png';
import regionedelVeneto from '../../assests/SSSRPositivoColori.png';
import venetoPrima from '../../assests/venetoPrima.png';
import DesktopMenuHeaderComponent from "./components/DesktopMenuHeaderComponent/DesktopMenuHeaderComponent";
import MobileMenuHeaderComponent from "./components/MobileMenuHeaderComponent/MobileMenuHeaderComponent";
import BannerComponent from "./components/BannerComponent/BannerComponent";
import { Link, useLocation } from "react-router-dom";
import { routesMap } from "../../routes";
import { useState, useContext } from "react";
import SearchComponent from "../SearchComponent/SearchComponent"
import { AppContext } from "../../contexts/appContext";

/**
 * @function HeaderComponent header
 * @param appYear the year displayed on the app homepage
 * @returns {JSX.Element}
*/
const HeaderComponent = () => {
    const location = useLocation();
    const { appYear } = useContext(AppContext);
    const showBanner = location.pathname === routesMap.NO_PAGE || location.pathname === routesMap.HOME_PAGE;
    const [openMenuHamburger, setOpenMenuHamburger] = useState(false);
    const renderHeader = () => (
        <div className="d-lg-flex">
            <Link className="btn headerBottom__item " to={ routesMap.HOME_PAGE } tabIndex="0" role="link" aria-label={`Relazione Socio Sanitaria della Regione del Veneto ${ appYear }`}>
                <span className="headerBottom__item--appName">RSSR</span>
                <span className="headerBottom__item--appYear">{ appYear }</span>
            </Link>
            <div className="headerBottom__item--appTitle align-self-center" aria-hidden="true" aria-label="Relazione Socio Sanitaria della Regione del Veneto">
                <div className="row">
                    <div className="col-12 headerBottom__item--firstTitle pt-lg-2 px-lg-4 p-0 m-0">Relazione Socio Sanitaria</div>
                    <div className="col-12 headerBottom__item--secondTitle px-lg-4 p-0 m-0">della Regione del Veneto</div>
                </div>
            </div>
        </div>
    );
    return (
        <>
            <div className="sticky-top">
                <div className="headerTop">
                    <div className="d-flex justify-content-between headerTop__container">
                        <Link className="btn headerTop__item align-self-center" to={ routesMap.HOME_PAGE } role="button">
                            <div className="align-self-center">
                                <img
                                    src={ venetoPrima }
                                    title={ "regionedelVeneto" }
                                    alt={ "Logo Regione del Veneto" }
                                    width={ 98 }
                                    height={ 60 }
                                />
                                <img
                                    src={ regionedelVeneto }
                                    title={ "regionedelVeneto" }
                                    alt={ "Logo Regione del Veneto" }
                                    width={ 136 }
                                    height={ 60 }
                                />
                            </div>
                        </Link>
                        <div className="align-self-center" tabIndex="0" role="img" aria-label="Logo Azienda Zero">
                            <img
                                src={ aziendaZero }
                                title={ "aziendaZero" }
                                alt={ "Logo Azienda Zero" }
                                width={ 128 }
                                height={ 60 }
                            /></div>
                    </div>
                </div>
                <div className="headerBottom">
                    <div className="row p-0 m-0">
                        <div className="col-12 col-lg p-0 m-0">
                            <div className="d-flex justify-content-between text-end d-lg-none">
                                <div className="headerBottom__item" style={ { padding: "15px 0px" } }>
                                    {/* <button className="btn headerBottom__item--menuButton" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMenu" aria-expanded="false" aria-controls="collapseMenu"> */ }
                                    <button className="btn headerBottom__item--menuButton" type="button" onClick={() => setOpenMenuHamburger(true)}>
                                        <span className="material-icons-outlined font-size-48">
                                            menu
                                        </span>
                                    </button>
                                </div>
                                <MobileMenuHeaderComponent setOpenMenuHamburger={() => setOpenMenuHamburger(false) }  openMenuHamburger={openMenuHamburger}></MobileMenuHeaderComponent>
                                <div>
                                    { renderHeader() }
                                </div>
                            </div>
                            <div className="d-lg-none headerBottom__item">
                                <SearchComponent></SearchComponent>
                            </div>
                            <div className="d-lg-flex d-none justify-content-between">
                                { renderHeader() }
                                <SearchComponent></SearchComponent>
                            </div>
                        </div>
                    </div>
                    <DesktopMenuHeaderComponent></DesktopMenuHeaderComponent>
                </div>

            </div>
            { showBanner ? <BannerComponent></BannerComponent> : null }
        </>
    );
};

HeaderComponent.propTypes = {};

HeaderComponent.defaultProps = {};

export default HeaderComponent;